import React from 'react';

const Contact = () => {
  return (
    <div className="contact-page" data-testid="contact-page">
      {/* Hero */}
      <section className="bg-gradient-to-r from-[#79c9ea] to-[#5ba8c8] text-white py-16">
        <div className="container-custom text-center">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 uppercase tracking-wide" data-testid="contact-title">CONTACTEZ-NOUS</h1>
          <p className="text-xl opacity-90">Notre équipe est à votre écoute</p>
          <p className="text-sm opacity-70 mt-3 max-w-md mx-auto italic">
            On aime les belles destinations, mais on aime surtout les belles rencontres.
          </p>
        </div>
      </section>

      {/* Contact Methods */}
      <section className="section">
        <div className="container-custom">
          <h2 className="text-4xl font-bold mb-12 text-[#1E3A5F] text-center">Comment nous joindre ?</h2>
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-stretch max-w-3xl mx-auto">
            {/* Email */}
            <a
              href="mailto:rhoneamitie@gmail.com"
              className="card p-6 text-center hover:shadow-2xl transition group"
              data-testid="contact-email"
            >
              <div className="w-14 h-14 rounded-full bg-[#5BC5D4]/10 flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition">
                <svg className="w-7 h-7 text-[#5BC5D4]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
              </div>
              <h3 className="text-lg font-bold mb-1 text-[#1E3A5F]">Email</h3>
              <div className="text-sm font-bold text-[#5BC5D4] break-all">rhoneamitie@gmail.com</div>
            </a>

            {/* WhatsApp */}
            <a
              href="https://wa.me/33660416218"
              target="_blank"
              rel="noopener noreferrer"
              className="card p-6 text-center hover:shadow-2xl transition group"
              data-testid="contact-whatsapp"
            >
              <div className="w-14 h-14 rounded-full bg-[#25D366]/10 flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition">
                <svg className="w-7 h-7 text-[#25D366]" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                </svg>
              </div>
              <h3 className="text-lg font-bold mb-1 text-[#25D366]">WhatsApp</h3>
              <div className="text-sm text-gray-600">Écrivez-nous directement</div>
            </a>
          </div>
        </div>
      </section>

      {/* Réseaux Sociaux */}
      <section className="section bg-gray-50" data-testid="social-section">
        <div className="container-custom">
          <h2 className="text-4xl font-bold mb-12 text-[#1E3A5F] text-center">Suivez-nous sur les réseaux</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
            <a
              href="https://www.facebook.com/share/1689AjKh3h/"
              target="_blank"
              rel="noopener noreferrer"
              className="card p-6 text-center hover:shadow-xl transition group"
              data-testid="social-facebook"
            >
              <svg className="w-12 h-12 mx-auto mb-3 text-[#1877F2] group-hover:scale-110 transition" fill="currentColor" viewBox="0 0 24 24">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
              <h3 className="font-bold">Facebook</h3>
            </a>

            <a
              href="https://www.instagram.com/kmlvoyages"
              target="_blank"
              rel="noopener noreferrer"
              className="card p-6 text-center hover:shadow-xl transition group"
              data-testid="social-instagram"
            >
              <svg className="w-12 h-12 mx-auto mb-3 text-[#E4405F] group-hover:scale-110 transition" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
              <h3 className="font-bold">Instagram</h3>
            </a>

            <a
              href="https://www.tiktok.com/@rhoneamitievoyage"
              target="_blank"
              rel="noopener noreferrer"
              className="card p-6 text-center hover:shadow-xl transition group"
              data-testid="social-tiktok"
            >
              <svg className="w-12 h-12 mx-auto mb-3 text-[#000000] group-hover:scale-110 transition" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
              </svg>
              <h3 className="font-bold">TikTok</h3>
            </a>

            <a
              href="https://www.youtube.com/@RHONEAMITIEVOYAGES"
              target="_blank"
              rel="noopener noreferrer"
              className="card p-6 text-center hover:shadow-xl transition group"
              data-testid="social-youtube"
            >
              <svg className="w-12 h-12 mx-auto mb-3 text-[#FF0000] group-hover:scale-110 transition" fill="currentColor" viewBox="0 0 24 24">
                <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.6 12 3.6 12 3.6s-7.5 0-9.4.5A3 3 0 0 0 .5 6.2 31 31 0 0 0 0 12a31 31 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1A31 31 0 0 0 24 12a31 31 0 0 0-.5-5.8zM9.6 15.6V8.4l6.2 3.6-6.2 3.6z" />
              </svg>
              <h3 className="font-bold">YouTube</h3>
            </a>

            <a
              href="https://www.snapchat.com/add/kmlvoyages"
              target="_blank"
              rel="noopener noreferrer"
              className="card p-6 text-center hover:shadow-xl transition group"
              data-testid="social-snapchat"
            >
              <svg className="w-12 h-12 mx-auto mb-3 text-[#FFFC00] group-hover:scale-110 transition" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12.206.793c.99 0 4.347.276 5.93 3.821.529 1.193.403 3.219.299 4.847l-.003.06c-.012.18-.022.345-.03.51.075.045.203.09.401.09.3-.016.659-.12 1.033-.301.165-.088.344-.104.464-.104.182 0 .359.029.509.09.45.149.734.479.734.838.015.449-.39.839-1.213 1.168-.089.029-.209.075-.344.119-.45.135-1.139.36-1.333.81-.09.224-.061.524.12.868l.015.015c.06.136 1.526 3.475 4.791 4.014.255.044.435.27.42.509 0 .075-.015.149-.045.225-.24.569-1.273.988-3.146 1.271-.059.091-.12.375-.164.57-.029.179-.074.36-.134.553-.076.271-.27.405-.555.405h-.03c-.135 0-.313-.031-.538-.076-.491-.106-.795-.18-1.29-.18-.36 0-.75.046-1.124.137-.99.251-1.813.9-2.744 1.618-1.19.899-2.55 1.936-4.628 1.936-2.079 0-3.439-1.037-4.628-1.936-.931-.718-1.754-1.367-2.744-1.618-.375-.09-.765-.137-1.124-.137-.585 0-.899.087-1.29.18-.179.045-.359.075-.539.075-.299 0-.48-.135-.554-.405-.061-.18-.105-.375-.135-.553-.045-.195-.105-.479-.165-.57-1.873-.283-2.906-.702-3.146-1.271-.029-.075-.044-.149-.044-.225-.015-.24.165-.465.42-.509 3.264-.54 4.73-3.879 4.791-4.02l.016-.029c.18-.345.224-.645.119-.869-.195-.434-.884-.658-1.332-.809-.136-.045-.256-.09-.346-.12-.809-.33-1.213-.72-1.213-1.17 0-.254.149-.54.464-.719.179-.12.39-.179.616-.179.134 0 .271.015.404.044.396.12.735.27 1.034.301.184 0 .315-.045.405-.09-.009-.165-.019-.33-.031-.51-.015-.18-.031-.36-.031-.539-.135-1.5-.27-3.659.3-4.852C7.86 1.068 11.216.793 12.206.793z"/>
              </svg>
              <h3 className="font-bold">Snapchat</h3>
            </a>
          </div>
        </div>
      </section>

      {/* Avis Google */}
      <section id="avis" className="section" data-testid="google-reviews">
        <div className="container-custom text-center">
          <h2 className="text-4xl font-bold mb-6 text-[#1E3A5F]">Ce que disent nos voyageurs</h2>
          <p className="text-xl text-gray-600 mb-8">Consultez les avis de nos clients sur Google</p>
          <a
            href="https://maps.app.goo.gl/ALqfQdbpnjYKvq4X7"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 btn-primary text-xl"
            data-testid="google-reviews-btn"
          >
            <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z"/>
            </svg>
            Voir nos avis Google
          </a>
        </div>
      </section>
    </div>
  );
};

export default Contact;
